import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  setItemStyle: {
    flex: 1,
  },
  container: {
    gap: 8,
    paddingRight: 8,
    marginBottom: 8,
  },
  headerContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  heading: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.darkBlue,
  },
  setContainer: { rowGap: 16 },
});
